export const Time = {
    time: 0,
    deltaTime: 0,
    scale: 1
}